import orderTranslationsHelper from "../../../../../../languages/order-translations.helper";
import {
  OrderTransportingOrderForwardingDeleteErrorType,
  OrderTransportingOrderForwardingDeleteAbandonedOrderError,
  OrderTransportingOrderForwardingDeleteDriverAssignedError,
} from "./order-transporting-order-forwarding-delete-error";

const createAbandonedOrderError =
  (): OrderTransportingOrderForwardingDeleteAbandonedOrderError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().cancelForwarding;

    return {
      message: translations.cancelForwardingAbandonedOrderError,
      params: {},
      type: OrderTransportingOrderForwardingDeleteErrorType.ABANDONED_ORDER,
    };
  };

const createDriverAssignedError =
  (): OrderTransportingOrderForwardingDeleteDriverAssignedError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().cancelForwarding;

    return {
      message: translations.cancelForwardingDriverAssignedError,
      params: {},
      type: OrderTransportingOrderForwardingDeleteErrorType.DRIVER_ASSIGNED,
    };
  };

const orderTransportingOrderForwardingDeleteErrorFactory = {
  createAbandonedOrderError,
  createDriverAssignedError,
};

export default orderTransportingOrderForwardingDeleteErrorFactory;
